import React from "react";
import moment from "moment";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import BarcodeReader from "react-barcode-reader";

import TextArea from 'antd/lib/input/TextArea';
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
} from "antd";
import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO
} from "../../../common/types/regularExpresionType";
import {
  PORCENTAJE_PERCEPCION,
  VALIDAR_STOCK
} from "../../../common/types/parametroType";


import dialog from "../../../common/utility/dialog";

import Footer from "./FormModal/Footer";
import Productos from "./FormModal/Productos";
import Referencias from "./FormModal/Referencias";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      result: "No result",
    };
    this.handleScan = this.handleScan.bind(this);

  }


  handleScan(data) {
    debugger
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue
    );
  }

  handleError(err) {
    alert("error");
    console.error(err);
  }


  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };


  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  completeDocumento = (e) => {
    var value = e.target.value;
    if (value.length === 0) return;

    var zeros = "";
    for (let index = 0; index < 8 - value.length; index++) {
      zeros += "0";
    }
    this.props.form.setFieldsValue({ documento: zeros + value }, () => {
      this.props.form.validateFields(["documento"], { force: true });
    });
  };

  documentoCustomValidation = (rule, value, callback) => {
    if (value === "00000000") callback("Documento no válido");

    callback();
  };

  handleSearchAutocompleteProveedor = async (value) => {
    const result = this.props.formValues.proveedores
      .filter((item) => {
        return global
          .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
          .match(global.formatSearch(value));
      })
      .slice(0, 75);
    this.props.form.setFieldsValue({ proveedores: result });
  };

  handleChangeAutocompleteProveedor = (a, element) => {

    this.props.form.setFieldsValue(
      {
        documentoEntidad: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idEntidad",
          element.props.data.idEntidad,
          this.props.form
        );
      }
    );
  };


  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleCalculateDetail = (row, property, value, numberDecimals) => {

    /********* Datos de parametro ******/
    var centaje = 8;
    /*********** Datos por fila ********/

    var flagRenta = (property === "arrflagRenta") ? value : this.props.form.getFieldValue(`arrflagRenta[${row.identifier}]`);
    var cantidad = 1;

    var precioUnitario = this.fetchFieldValue(row.identifier, "arrPrecio");

    var precioNuevo = precioUnitario;

    var totalDetalle = precioUnitario * cantidad;


    var importe = totalDetalle;
    var retencion = 0;
    var total = totalDetalle;

    if (property === "arrflagRenta") {
      if (flagRenta) {
        retencion = (precioUnitario * centaje) / 100;
        importe = precioUnitario - retencion;
      } else {
        retencion = 0;
        importe = precioUnitario - retencion;

      }
    } else {
      if (flagRenta) {
        retencion = (precioUnitario * centaje) / 100;
        importe = precioUnitario - retencion;
      } else {
        retencion = 0;
        importe = precioUnitario - retencion;

      }
    }




    /*********** Calculo precios unitarios ********/
    var precioUnitarioSinIGV = 0;


    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    detalleProductosFilter.push({
      identifier: row.identifier,
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      idProducto: row.idProducto,
      idTipoProducto: row.idTipoProducto,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario: precioNuevo,
      precioNuevo,
      numeroLote: this.props.form.getFieldValue(`arrLote[${row.identifier}]`),
      flagRenta,
      importe,
      retencion,
      total
    });



    var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));
    var sumaSubTotal = 0;
    var sumaIgv = sumaTotal - sumaSubTotal
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/


    this.props.form.setFieldsValue({
      sumaTotal: (precioNuevo - retencion),
      sumaSubTotal: sumaTotal,
      sumaIgv: retencion,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      [`arrflagRenta[${row.identifier}]`]: flagRenta,
      [`arrPrecio[${row.identifier}]`]: precioNuevo.toFixed(5),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(3),
      [`arrTotal[${row.identifier}]`]: importe.toFixed(2),
      [`arrRetencion[${row.identifier}]`]: retencion.toFixed(2),

    });

  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchSumaTotalAfecto = (
    identifier,
    paramflagRenta,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagRenta =
        identifier === key
          ? paramflagRenta
          : this.props.form.getFieldValue("arrflagRenta")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (flagRenta && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalInafecto = (
    identifier,
    paramflagRenta,
    paramFlagGratuito,
    paramFlagExonerado,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagRenta =
        identifier === key
          ? paramflagRenta
          : this.props.form.getFieldValue("arrflagRenta")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      var flagExonerado =
        identifier === key
          ? paramFlagExonerado
          : this.props.form.getFieldValue("arrFlagExonerado")[key];
      if (!flagRenta && !flagGratuito && !flagExonerado) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchSumaTotalExonerado = (
    identifier,
    paramFlagExonerado,
    paramFlagGratuito,
    total
  ) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue("arrTotal"));
    for (var [key, value] of Object.entries(obj)) {
      var flagExonerado =
        identifier === key
          ? paramFlagExonerado
          : this.props.form.getFieldValue("arrFlagExonerado")[key];
      var flagGratuito =
        identifier === key
          ? paramFlagGratuito
          : this.props.form.getFieldValue("arrFlagGratuito")[key];
      if (flagExonerado && !flagGratuito) {
        suma += identifier === key ? total : parseFloat(value);
      }
    }
    return suma;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  fetchReferencias = (values) => {
    var result = [];
    // 
    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaHonorarioReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined ||
      values.arrIdReferencia === undefined ||
      values.arrIdReferenciaOrigen === undefined ||
      values.arrFlagInterno === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };


  validate_fechaMayorQue(fechaInicial, fechaFinal) {
    var valuesStart = fechaInicial.split("/");
    var valuesEnd = fechaFinal.split("/");

    // Verificamos que la fecha no sea posterior a la actual
    var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
    var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);
    if (dateStart == dateEnd) {
      return true;
    }
    if (dateStart > dateEnd) {
      return true;
    }
    return false;
  }


  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (values.detalleProductos.length == 0) {
        dialog.error("Agrega detalle de Productos !");
        return false;
      }

      if (!err) {
        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante,
          idEntidad: values.idEntidad.key,
          idMoneda: values.idMoneda.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idUsuarioRegistro: 0,
          idEstablecimientoEntidad: values.idEstablecimientoEntidad.key,

          serie: values.serie.toUpperCase(),
          documento: values.documento,
          idProyecto: values.idProyecto === undefined ? 0 : values.idProyecto.key,
          fechaRecepcionStr: values.fechaRecepcionStr.format("DD/MM/YYYY"),
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          tipoCambio: 0,
          observacion: values.observacion,
          importe: values.sumaSubTotal,
          retencion: values.sumaIgv,
          total: values.sumaTotal,
          listaHonorarioDetalle: values.detalleProductos,
          listaHonorarioReferencia: this.fetchReferencias(values),
        };


        if (this.validate_fechaMayorQue(data.fechaStr, data.fechaRecepcionStr)) {
          dialog.warning("La fecha de fecha recepción debe ser mayor que la fecha de emision");

          return false;
        }
        this.props.onSave(data, this.props.form);
      }
    });
  };




  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });



    // var sumaImporteDescuento = this.fetchFieldValueSum(
    //   row.identifier,
    //   "arrImporteDescuento",
    //   0
    // );
    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(
      row.identifier,
      "arrSubTotal",
      0
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      // sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);

  };



  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator("proveedores", {
      initialValue: this.props.formValues.proveedores.filter((m) => {
        return m.id === this.props.formValues.idEntidad;
      }),
    });


    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("idTipoComprobante", {
      initialValue: this.props.formValues.idTipoComprobante,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });
    getFieldDecorator('entidades', { initialValue: [] });



    return (
      <Modal
        title={this.props.formValues.id === 0 ? `Registrar Recibos Honorarios` : `Modificar Recibos Honorarios`}
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={this.props.formValues.saveLoading}
            onClick={this.handleOk}
          >
            Guardar
          </Button>,
        ]}
        style={{ top: 30 }}
        width="1100px"
      >

        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        }
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Recepción">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaRecepcionStr", {
                      initialValue: moment(
                        this.props.formValues.fechaRecepcionStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        {
                          idListaPrecio: undefined,
                        },
                        () => {
                          this.props.onChange("idMoneda", option.key);
                        }
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

          </div>
          <div className="row">

            <div className="col-md-4 form-group">
              <Form.Item label="Nro Documento">
                <Form.Item style={{ width: "100%" }}>
                  {getFieldDecorator("documentoEntidad", {
                    initialValue: this.props.formValues.documentoEntidad,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      loading={this.props.formValues.proveedorLoading}
                      onSearch={(value) =>
                        this.props.onBuscarProveedor(value, this.props.form)
                      }
                      maxLength={20}
                    />
                  )}
                </Form.Item>


              </Form.Item>
            </div>

            <div className="col-md-8 form-group">
              <Form.Item label="Proveedor">
                <Form.Item style={{ width: "100%" }}>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idEntidad", {
                      initialValue: this.props.formValues.idEntidad
                        ? { key: this.props.formValues.idEntidad }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        style={{
                          width: `calc(100% - 40px)`,
                          borderTopLeftRadius: "0px",
                        }}
                        placeholder={"Búsqueda de Proveedor"}
                        optionFilterProp="children"
                        showArrow={false}
                        onSearch={this.handleSearchAutocompleteProveedor}
                        onChange={this.handleChangeAutocompleteProveedor}
                      >
                        {getFieldValue("proveedores").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}
                    <Button
                      className="btn-autocomplete"
                      style={{ width: "40px", fontSize: "14px" }}
                      icon={
                        this.props.form.getFieldValue("idEntidad")
                          ? "close"
                          : "search"
                      }
                      onClick={() => {
                        this.props.form.setFieldsValue(
                          {
                            idEntidad: undefined,
                            documentoEntidad: "",
                            idEstablecimientoEntidad: undefined,
                          },
                          () => {
                            this.props.onChange("direcciones-clear");
                          }
                        );
                      }}
                    />
                  </InputGroup>
                </Form.Item>

              </Form.Item>
            </div>

          </div>



          <div className="row">
            <div className="col-md-8 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoEntidad", {
                  initialValue: this.props.formValues
                    .idEstablecimientoEntidad
                    ? {
                      key: this.props.formValues
                        .idEstablecimientoEntidad,
                    }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: this.props.formValues.idTipoComprobante == 6 ? false : true,
                          message: "Requerido",
                          whitespace: true,
                        },
                        // {
                        //   validator: this.serieCustomValidation,
                        // },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        maxLength={4}
                        disabled={this.props.formValues.idTipoComprobante == 6}
                        style={{ textTransform: "uppercase" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                      rules: [
                        {
                          validator: this.documentoCustomValidation,
                        },
                        {
                          required: true,
                          message: "Requerido",
                          whitespace: true,
                        }
                      ],
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        onBlur={this.completeDocumento}
                        onKeyPress={global.onKeyPressDecimals}

                        maxLength={20}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
          </div>




          <div className="row">


            <div className="col-md-4 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.onChange("idEstablecimiento", option.key, this.props.form);
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


            <div className="col-md-4 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator("idProyecto", {
                  initialValue: this.props.formValues.idProyecto
                    ? { key: this.props.formValues.idProyecto }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator('observacion', {
                  initialValue: this.props.formValues.observacion
                })(
                  <TextArea
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      disabled={this.props.formValues.listaHonorarioDetalle.length >= 1 && this.props.formValues.activeKey == "1"}
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>
                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Servicios
                    </span>
                  }
                  key="1"
                >
                  <Productos
                    dataSource={this.props.formValues.listaHonorarioDetalle}
                    onRemove={this.handleRemoverProducto}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Referencias
                    </span>
                  }
                  key="2"
                >
                  <Referencias
                    dataSource={
                      this.props.formValues.listaHonorarioReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
          />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormModal);